var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 31.875C9.29125 31.875 11.25 29.9162 11.25 27.5C11.25 25.0838 9.29125 23.125 6.875 23.125C4.45875 23.125 2.5 25.0838 2.5 27.5C2.5 29.9162 4.45875 31.875 6.875 31.875Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 6.25L37.5 12.5L31.25 18.75",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 27.5H12.5C14.4891 27.5 16.3968 26.7098 17.8033 25.3033C19.2098 23.8968 20 21.9891 20 20C20 18.0109 20.7902 16.1032 22.1967 14.6967C23.6032 13.2902 25.5109 12.5 27.5 12.5H37.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowArrow);
export default __webpack_public_path__ + "static/media/FlowArrow.1d20e24bd0ed9ebb50518e71ead8ab67.svg";
export { ForwardRef as ReactComponent };